import React from 'react'

class ErrorBoundary extends React.Component<
  object,
  { hasError: boolean; errorInfo: any; showTooltip: boolean }
> {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorInfo: null, showTooltip: false }
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo)
    this.setState({
      errorInfo: JSON.stringify(errorInfo.componentStack || errorInfo),
    })
  }

  toggleTooltip = () => {
    this.setState((prevState) => ({
      showTooltip: !prevState.showTooltip,
    }))
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>
            <b style={{ color: 'red' }}>[에러]</b> 무언가 잘못 되었습니다..!
          </h1>
          <div
            style={{
              position: 'relative',
              fontSize: 14,
              color: 'gray',
              cursor: 'pointer',
              overflow: 'visible',
              ...(this.state.showTooltip && {
                minHeight: '300px',
              }),
            }}
            onMouseEnter={this.toggleTooltip}
            onMouseLeave={this.toggleTooltip}
          >
            에러 정보
            {this.state.showTooltip && (
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  height: '100%',
                  width: '100%',
                  backgroundColor: 'black',
                  color: 'white',
                  padding: '5px',
                  borderRadius: '3px',
                  zIndex: 1,
                  fontSize: '14px',
                  overflow: 'auto',
                }}
              >
                {this.state.errorInfo}
              </div>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
